import React, { type HTMLAttributes } from 'react';

import { Webform } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { ParagraphWebform as Type } from '../../../types/uncinc_profile/paragraphs';

interface ParagraphWebformProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphWebform: React.FC<ParagraphWebformProps> = ({ id, entity }) => {
  const paragraphWebform = entity.toJS();
  const { status, target_id: targetId } = paragraphWebform.field_webform[0];

  return (
    <div id={id} className="Paragraph ParagraphWebform">
      <Container>
        <Webform id={targetId} status={status} onlySubmitVisibleFields />
      </Container>
    </div>
  );
};

export default ParagraphWebform;
